import React, { useState } from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { Button } from './ui/button';
import AnimateOnScroll from './AnimateOnScroll';
import { faqSection } from '../content/landingContent';

export default function FAQSection() {
  const [showAll, setShowAll] = useState(false);
  const visibleItems = showAll ? faqSection.items : faqSection.items.slice(0, faqSection.initialVisible);

  return (
    <section id="faq" className="bg-white py-20 lg:py-28" data-testid="faq-section">
      <div className="max-w-2xl mx-auto px-6 lg:px-8">
        <AnimateOnScroll>
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-stone-900" data-testid="faq-heading">
              {faqSection.headline}
            </h2>
            <p className="mt-4 text-stone-500">
              {faqSection.subheadline}
            </p>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll>
          <Accordion type="single" collapsible defaultValue="faq-0">
            {visibleItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="border-b border-stone-200"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-base font-semibold text-stone-900 hover:no-underline py-5">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-stone-600 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </AnimateOnScroll>

        {faqSection.items.length > faqSection.initialVisible && (
          <div className="flex justify-center mt-8">
            <Button
              variant="outline"
              onClick={() => setShowAll(!showAll)}
              className="border border-stone-300 text-stone-600 rounded-lg hover:bg-stone-50"
              data-testid="faq-toggle-btn"
            >
              {showAll ? faqSection.showLessLabel : faqSection.showMoreLabel}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}
